import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const LowStimContext = createContext(null);

export function LowStimProvider({ children }) {
  const { actor } = useAuth();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (actor && typeof actor === "object") setEnabled(!!actor.low_stim_mode);
  }, [actor]);

  useEffect(() => {
    const body = document.body;
    if (enabled) body.classList.add("low-stim");
    else body.classList.remove("low-stim");
  }, [enabled]);

  const toggle = useCallback(async () => {
    const next = !enabled;
    setEnabled(next);
    if (actor && typeof actor === "object") {
      try { await api.put(`/profile/low-stim?value=${next}`); } catch (e) { /* ignore */ }
    }
  }, [enabled, actor]);

  return (
    <LowStimContext.Provider value={{ enabled, toggle, setEnabled }}>
      {children}
    </LowStimContext.Provider>
  );
}

export function useLowStim() { return useContext(LowStimContext); }
